module.exports = __webpack_public_path__ + "img/c_1_1.60fde3c8.png";